(function () {
  // --- CACHE DOM ELEMENTS ---
  const cache = {};

  // --- DECLARACIONES GLOBALES ---
  let jsonDataPro = {};
  let themeData = {};
  let outsideClickHandler = null; // Para gestionar click outside de toggles

  const minTotalPrice = {
    "19 €": 24500,
    "23 €": 24500,
    "35 €": 24500,
    "9 €": 9800,
    " ": 27500,
    "": 27500
  };

  const holidays = new Set([
    "2025-01-01", "2025-04-06", "2025-05-01", "2025-08-15", "2025-10-12",
    "2025-11-01", "2025-12-06", "2025-12-08", "2025-12-25",
    "2025-06-24", "2025-09-11", "2025-09-24"
  ]);

  const expressShippingCosts = {
    BA: 'KM38', BG: 'лв38', CZ: 'Kč474', DK: 'kr142', HU: 'Ft7652',
    IS: 'kr2788', LI: 'CHF18', NO: 'kr221', PL: 'zł81', RO: 'lei97',
    RS: 'РСД2230', SE: 'kr208', CH: 'CHF18', TR: '₺826', CA: '$29',
    CY: '€21', HK: 'HK$180', MT: '€21', SG: '$29',
    HR: '€19', EE: '€19', FI: '€19', DE: '€19', GR: '€19', IE: '€19',
    LV: '€19', LT: '€19', LU: '€19', MC: '€19', ME: '€19', NL: '€19',
    PT: '€19', SM: '€19', SK: '€19', SI: '€19', VA: '€19',
    FR: '€19', IT: '€19', ES: '€19', UK: '£16', GB: '£16',
    US: '$14', USA: '$14', AE: 'AED76', default: '€35'
  };

  // --- CACHE DOM FUNCTION ---
  function cacheDOM() {
    cache.productJSON = document.querySelector('[data-product-json]');
    cache.variants = document.querySelectorAll('.variant input[type="radio"]');
    cache.shippingBox = document.querySelector('#main-shipping-info');
    cache.tabOverlay = document.getElementById('TabContentOverlay');
    cache.firstColumn = document.querySelector('.firstColumn');
    cache.productInfo = document.getElementsByTagName('product-info')[0];
    cache.completeLook = document.querySelector('#complete-look');
    
    // Modal elements
    cache.gptModal = document.getElementById("gpt");
    cache.tabContents = document.getElementsByClassName("tab-content");
    cache.tabButtons = document.getElementsByClassName("tab");

    if (cache.completeLook) cache.completeLook.style.display = 'none';
  }

  // --- STICKY BEHAVIOR VALIDATION ---
  function shouldEnableSticky() {
    const isDesktop = window.innerWidth > 767;
    if (!isDesktop) return false;
    
    const productInfoElement = cache.productInfo || document.getElementsByTagName('product-info')[0];
    if (!productInfoElement) return false;
    
    const productInfoHeight = productInfoElement.offsetHeight;
    const viewportHeight = window.innerHeight;
    
    // Only enable if content overflows viewport
    return productInfoHeight > viewportHeight;
  }

  // --- DOM READY INIT ---
  document.addEventListener('DOMContentLoaded', () => {
    // Cache DOM elements first
    cacheDOM();
    
    // Inicializar datos
    if (cache.productJSON) jsonDataPro = JSON.parse(cache.productJSON.innerHTML);
    themeData = JSON.parse(localStorage.getItem('themeData') || '{}');

    // Setup event listeners
    setupGlobalEventListeners();
    
    // Initialize functionality
    updateVariantBorders();
    setupVariantListeners();
    // setupToggleDivScroll(); // Sticky behavior disabled
    
    showCompleteLookIfPresent();
    
  });

  // --- GLOBAL EVENT LISTENERS ---
  function setupGlobalEventListeners() {
    // Single click handler for all interactions
    document.addEventListener('click', handleGlobalClick);
    
    // Keyboard handler
    document.addEventListener('keydown', handleKeydown);
  }

  function handleGlobalClick(event) {
    // Handle size chart modal
    if (event.target === cache.gptModal) {
      event.stopPropagation();
      event.preventDefault();
      openMeasureModal();
      return;
    }

    // Handle outside clicks for toggle divs
    if (outsideClickHandler) {
      outsideClickHandler(event);
    }
  }

  function handleKeydown(event) {
    // Close modal on Escape
    if (event.key === "Escape" && cache.gptModal) {
      cache.gptModal.classList.remove("show");
      document.body.style.overflow = '';
    }
  }

  // --- MODAL FUNCTIONS ---
  window.openMeasureModal = function() {
    if (!cache.gptModal) return;
    
    const isOpen = cache.gptModal.classList.contains("show");
    
    if (isOpen) {
      cache.gptModal.classList.remove("show");
      document.body.style.overflow = '';
    } else {
      cache.gptModal.classList.add("show");
      document.body.style.overflow = 'hidden';
    }
  };

  window.showTabContent = function(tabIndex) {
    if (!cache.tabContents || !cache.tabButtons) return;
    
    for (let i = 0; i < cache.tabContents.length; i++) {
      const isActive = i + 1 === tabIndex;
      cache.tabContents[i].classList.toggle("active", isActive);
      cache.tabButtons[i].classList.toggle("active", isActive);
    }
  };

  window.showSubTabContent = function(subTabIndex, tabContentId) {
    const tabContent = document.getElementById(tabContentId);
    if (!tabContent) return;
    
    const subTabContents = tabContent.getElementsByClassName("sub-tab-content");
    const subTabButtons = tabContent.getElementsByClassName("sub-tab");
    
    for (let i = 0; i < subTabContents.length; i++) {
      const isActive = i + 1 === subTabIndex;
      subTabContents[i].classList.toggle("active", isActive);
      subTabButtons[i].classList.toggle("active", isActive);
    }
  };

  // --- TABS & TOGGLES ---
window.handleTabInteraction = function (evt, type, targetId) {
  const isToggle = type === 'toggle';
  const isTab = type === 'tab';

  const clearToggleUnderscores = () => {
    document.querySelectorAll('.modal_opener a').forEach(el => el.style.textDecoration = 'none');
  };

  if (isToggle) {
    const overlay = document.getElementById('TabContentOverlay');
    if (!overlay) return;
    
    const contentContainer = overlay.querySelector('.tab-overlay-content');
    const template = document.getElementById('tab-templates');
    
    if (!template || !contentContainer) return;
    
    const isHidden = !overlay.classList.contains('active');
    const currentTab = overlay.dataset.currentTab;
    
    clearToggleUnderscores();

    if (isHidden || currentTab !== targetId) {
      const templateContent = template.content.querySelector(`[data-tab-content="${targetId}"]`);
      if (templateContent) {
        contentContainer.innerHTML = templateContent.innerHTML;
        overlay.classList.add('active');
        overlay.dataset.currentTab = targetId;
        evt.currentTarget.style.textDecoration = 'underline';

        setupOutsideClickHandler(overlay);
        evt.stopPropagation();
      }
    } else {
      closeTabOverlay();
    }
  }

  if (isTab) {
    const tabContents = document.querySelectorAll('.tabsphone');
    const tabBtns = document.querySelectorAll('.tab-btn');

    tabContents.forEach(tab => tab.classList.remove('active'));
    tabBtns.forEach(btn => {
      btn.classList.remove('active');
      btn.style.textDecoration = 'none';
    });

    document.getElementById(targetId)?.classList.add('active');
    evt.currentTarget.classList.add('active');
    evt.currentTarget.style.textDecoration = 'underline';
  }
};

// --- ÚNICA VERSIÓN DE CIERRE (Mantenla así) ---
window.closeTabOverlay = function() {
  const overlay = document.getElementById('TabContentOverlay');
  if (overlay) {
    overlay.classList.remove('active');
    overlay.dataset.currentTab = '';
    
    // Limpieza de underscores
    document.querySelectorAll('.modal_opener a').forEach(el => {
      el.style.textDecoration = 'none';
    });
    
    removeOutsideClickHandler();
  }
};

  function setupOutsideClickHandler(targetDiv) {
    removeOutsideClickHandler(); // Remove previous handler
    
    outsideClickHandler = function(event) {
      const contentDiv = targetDiv.querySelector('.tab-overlay-content');
      const closeButton = targetDiv.querySelector('.close-tab-overlay');
      
      // Cerrar si hacemos click fuera del contenido (pero dentro del overlay o fuera)
      if (!isContentChild(event.target, contentDiv) && !isContentChild(event.target, closeButton)) {
        closeTabOverlay();
      }
    };
    
    // Agregar listener con un pequeño delay para evitar cerrar inmediatamente
    setTimeout(() => {
      document.addEventListener('click', outsideClickHandler);
    }, 10);
  }

  function removeOutsideClickHandler() {
    if (outsideClickHandler) {
      document.removeEventListener('click', outsideClickHandler);
      outsideClickHandler = null;
    }
  }

  function isContentChild(element, targetDiv) {
    return targetDiv && (targetDiv === element || targetDiv.contains(element));
  }

  // --- COMPLEMENTARY ---
  function showCompleteLookIfPresent() {
    setTimeout(() => {
      // 1. Buscamos el contenedor de la App (Frequently Bought)
      const appContainer = document.querySelector('.cbb-frequently-bought-container');
      
      if (appContainer && cache.completeLook) {
        // 2. Si la App cargó, decidimos el tipo de display según el dispositivo
        if (window.innerWidth <= 768) {
          cache.completeLook.style.display = 'inline';
        } else {
          // En escritorio aplicamos block (que ahora funcionará sin el !important)
          cache.completeLook.style.display = 'block';
        }
      } else if (cache.completeLook) {
        // 3. Si la App NO cargó, nos aseguramos de que siga oculto
        cache.completeLook.style.display = 'none';
      }
    }, 1200); // Un pelín más de tiempo para asegurar que la App de terceros inyectó su HTML
  }

  // --- VARIANTS ---
  function setupVariantListeners() {
    const variants = cache.variants || document.querySelectorAll('.variant input[type="radio"]');
    variants.forEach(variant => variant.addEventListener('change', updateVariantBorders));
  }

  function updateVariantBorders() {
    const selectedVariant = document.querySelector('.variant input[type="radio"]:checked');
    const giftCardPro = jsonDataPro['product']?.tags?.includes("Gift Card");
  
    if (!giftCardPro) {
      let selectedVariantId;
      
      if (selectedVariant) {
        // Hay variantes y una está seleccionada
        selectedVariantId = selectedVariant.getAttribute('data-variant-id');
      } else {
        // No hay variantes o ninguna seleccionada - usar el producto principal
        selectedVariantId = jsonDataPro.selected_variant_id || 
                           jsonDataPro.product?.variants?.[0]?.id ||
                           null;
      }
      
      builderBox(
        themeData.shippingCost,
        themeData.country_name,
        minTotalPrice,
        selectedVariantId
      );
    }
  }

  // --- ENVÍO Y FECHAS ---
  function addBusinessDays(days, checkHolidays = true) {
    const currentDate = new Date();
    
    // 1. Detectar idioma (usando la variable que añadimos a theme.liquid)
    const lang = (window.themeTranslations && window.themeTranslations.language) || 'en';

    // 2. Lógica de hora de corte (12:00 PM Madrid)
    const spanishTime = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid',
      hour: '2-digit',
      minute: '2-digit'
    }).format(currentDate);

    const [hours, minutes] = spanishTime.split(':').map(num => parseInt(num, 10));
    if (hours > 12 || (hours === 12 && minutes > 0)) days++;

    // 3. Calcular días hábiles saltando fines de semana y festivos
    let count = 0;
    while (count < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        let formattedDate = currentDate.toISOString().split('T')[0];
        if (checkHolidays && typeof holidays !== 'undefined' && holidays.has(formattedDate)) continue;
        count++;
      }
    }

    const dayOfMonth = currentDate.getDate();
    // 4. Traducir mes según el idioma de la tienda
    const month = currentDate.toLocaleString(lang, { month: 'short' });

    // 5. Retornar formato según el idioma
    if (lang === 'es') {
      // Formato para España: "23 dic"
      return `${dayOfMonth} ${month}`;
    } else {
      // Formato para Inglés: "Dec 23rd"
      const ordinalDay = getOrdinalSuffix(dayOfMonth);
      return `${month} ${ordinalDay}`;
    }
  }

  function getOrdinalSuffix(day) {
    const lang = window.themeTranslations.language || 'en';
    if (lang === 'es') return day; // En español simplemente devolvemos el número

    const suffixes = ["th", "st", "nd", "rd"];
    const exceptions = [11, 12, 13];
    const dayOfMonth = day % 100;
    if (exceptions.includes(dayOfMonth)) return `${day}th`;
    return `${day}${suffixes[(dayOfMonth % 10)] || suffixes[0]}`;
  }

  async function applyer(string, array) {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Failed to fetch cart data");
      const data = await response.json();
      const totalPrice = data.items_subtotal_price + jsonDataPro.product.price;
      return totalPrice >= array[string];
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return false;
    }
  }

async function builderBox(shippingCost, country, priceThresholds, variantID) {
  const container = cache.shippingBox || document.querySelector('#main-shipping-info');
  if (!container) return;

  container.innerHTML = '';
  container.style.display = 'none';

  const variant = getVariantById(variantID || jsonDataPro.selected_variant_id);
  if (!variant?.available) return;

  const preOrderDate = jsonDataPro[variant.id]?.pre_order_date || null;
  const qualifiesForFreeShipping = await applyer(shippingCost, priceThresholds);
  const hasShippingCost = shippingCost && shippingCost.trim();
  
  // ==========================================================
  // CÁLCULO DE TEXTOS (LÓGICA DEL CÓDIGO ORIGINAL)
  // ==========================================================
  
  // Check if country is US or USA for duties text (ES added for testing)
  const isUS = themeData.country_code === 'US' || themeData.country_code === 'USA' || 
                 country === 'US' || country === 'USA';
  
  // Ensure country name is translated (use themeData.country_name which is always translated)
  const translatedCountry = window.themeData?.country_name || country;
                 
  // 1. Texto de envío
  const shippingText = qualifiesForFreeShipping
      ? window.themeTranslations.free_delivery.replace('{{ country }}', translatedCountry)
      : hasShippingCost 
        ? window.themeTranslations.estimated_cost.replace('{{ country }}', translatedCountry).replace('{{ cost }}', shippingCost)
        : window.themeTranslations.calculated_at_checkout.replace('{{ country }}', translatedCountry);
        
  // 2. Texto de tiempo de entrega
  const deliveryText = preOrderDate
    ? window.themeTranslations.preorder_starts.replace('{{ date }}', preOrderDate)
    : hasShippingCost 
      ? window.themeTranslations.arrives_between.replace('{{ min }}', addBusinessDays(3)).replace('{{ max }}', addBusinessDays(5))
      : window.themeTranslations.delivery_calculated;
      
  // ==========================================================
  // CASO 1: GESTIÓN DE PRE-ORDER (NUEVO ESTILO, ORDEN INVERSO DE LA INFO)
  // ==========================================================
  if (preOrderDate) {
      const preOrderBox = document.createElement('div');
      preOrderBox.className = 'shipping-box pre-order-info'; 
      
      const textContainer = document.createElement('div');
      textContainer.className = 'shipping-text-container';

      // 1. Línea Superior (TIEMPO DE ENTREGA: Shipping starts...)
      textContainer.appendChild(createTextBlock('top', deliveryText)); 
      
      // 2. Línea Inferior (COSTE: Free delivery / Estimated shipping cost)
      textContainer.appendChild(createTextBlock('sub', shippingText)); 

      preOrderBox.appendChild(textContainer);
      container.appendChild(preOrderBox);
      container.style.display = 'block'; 
      
      return; 
  }
  
  // ==========================================================
  // CASO 2: ENVÍO NORMAL (Tu código con corrección de threshold)
  // ==========================================================

  // --- Shipping Box 1: ARRIVES + Holiday Guarantee / Coste Estimado ---
  const firstBox = document.createElement('div');
  firstBox.className = 'shipping-box first';
  
  // Lógica de threshold para la línea inferior del envío normal
  const subTextNormal = qualifiesForFreeShipping 
    ? window.themeTranslations.holiday_guarantee
    : shippingText; // Si no es gratis, usa el shippingText (el coste estimado)

  // 1. Crear e insertar el SVG
  const svgMarkup = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
      <path fill="#0032A7" fill-rule="evenodd" d="M10.559.725c.414.12.784.437 1.523 1.07l.215.186c.284.243.426.365.584.456a2 2 0 0 0 .645.239c.179.033.366.033.74.033.955 0 1.433 0 1.808.16a2 2 0 0 1 1.057 1.056c.16.376.16.853.16 1.809 0 .374 0 .56.033.74a2 2 0 0 0 .238.645c.092.157.214.3.457.583l.185.216c.633.739.95 1.109 1.071 1.523a2 2 0 0 1 0 1.119c-.12.414-.438.784-1.071 1.523l-.185.216c-.243.284-.365.426-.457.583a2 2 0 0 0-.238.645c-.033.18-.033.366-.033.74 0 .956 0 1.433-.16 1.808a2 2 0 0 1-1.057 1.057c-.375.16-.853.16-1.808.16-.374 0-.561 0-.74.033a2 2 0 0 0-.645.239c-.158.091-.3.213-.584.456l-.215.185c-.74.634-1.109.95-1.524 1.071a2 2 0 0 1-1.118 0c-.415-.12-.784-.437-1.523-1.07l-.21-.18c-.29-.25-.435-.373-.596-.466a2 2 0 0 0-.631-.234c-.183-.034-.375-.034-.759-.034-.969 0-1.454 0-1.832-.162a2 2 0 0 1-1.048-1.048c-.162-.378-.162-.86-.162-1.823 0-.374 0-.561-.033-.74a2 2 0 0 0-.233-.635c-.09-.158-.211-.301-.453-.586l-.194-.229c-.622-.735-.934-1.102-1.053-1.514a2 2 0 0 1 0-1.11c.12-.41.43-.778 1.053-1.513l.194-.229c.242-.285.363-.428.453-.586a2 2 0 0 0 .233-.635c.033-.179.033-.366.033-.74 0-.963 0-1.445.162-1.823A2 2 0 0 1 3.89 2.871c.379-.162.863-.162 1.832-.162.384 0 .576 0 .759-.034a2 2 0 0 0 .631-.234c.161-.093.306-.217.596-.465l.21-.18C8.656 1.162 9.025.846 9.44.725a2 2 0 0 1 1.119 0Zm3.304 6.245a.75.75 0 0 0-1.06 0l-3.637 3.635L8.03 9.47a.75.75 0 1 0-1.06 1.06l1.667 1.667a.751.751 0 0 0 1.06 0l4.166-4.167a.75.75 0 0 0 0-1.06Z" clip-rule="evenodd"/>
    </svg>
  `;
  firstBox.insertAdjacentHTML('beforeend', svgMarkup);

  // 2. Crear el nuevo contenedor para los textos
  const textContainer = document.createElement('div');
  textContainer.className = 'shipping-text-container';
  
  // 3. Insertar los bloques de texto 'top' (ARRIVES) y 'sub' (COSTO/GARANTÍA)
  textContainer.appendChild(createTextBlock('top', window.themeTranslations.arrives_range.replace('{{ range }}', getDeliveryRange(3, 5).toUpperCase())));
  textContainer.appendChild(createTextBlock('sub', subTextNormal)); 

  // 4. Añadir el contenedor de texto a la caja principal
  firstBox.appendChild(textContainer);

  // 5. Añadir la caja principal al contenedor padre
  container.appendChild(firstBox);

  // --- Shipping Box 2: Free & Fast + Express ---
  if (hasShippingCost) {
    const secondBox = document.createElement('div');
    secondBox.className = 'shipping-box second';

    const express = createExpressContainer(); 

    // Añadir Free & Fast solo si qualify for free shipping
    const expressDiv = express.querySelector('.express_shipping');
    if (expressDiv && qualifiesForFreeShipping) {
      const needItSoonSpan = expressDiv.querySelector('span');
      if (needItSoonSpan) {
        const textContainer = document.createElement('div');
        textContainer.className = 'shipping-text-container';
        const freeFastSpan = document.createElement('span');
        freeFastSpan.className = 'free-fast-shipping';
        // Ensure country name is translated (use themeData.country_name which is always translated)
        const translatedCountry = window.themeData?.country_name || country;
        freeFastSpan.textContent = window.themeTranslations.free_fast_shipping.replace('{{ country }}', translatedCountry);
        textContainer.appendChild(freeFastSpan);
        textContainer.appendChild(needItSoonSpan);
        expressDiv.appendChild(textContainer);
      }
    }

    secondBox.appendChild(express);
    container.appendChild(secondBox);
  }

  container.style.display = 'block';
}


  function getVariantById(id) {
    return jsonDataPro.product?.variants?.find(v => v.id == id);
  }

  function createTextBlock(className, text) {
    const p = document.createElement('p');
    p.className = className;
    p.textContent = text;
    return p;
  }

  function getDeliveryRange(startDays, endDays) {
    const startDate = new Date();
    const endDate = new Date();
    
    // Get locale from multiple sources
    let locale = 'en';
    if (window.themeTranslations && window.themeTranslations.language) {
      locale = window.themeTranslations.language;
    } else if (document.documentElement && document.documentElement.lang) {
      locale = document.documentElement.lang;
    } else if (window.Shopify && window.Shopify.locale) {
      locale = window.Shopify.locale;
    }

    const dateConnector = window.themeTranslations?.date_connector || '';

    addBusinessDaysToDate(startDate, startDays);
    addBusinessDaysToDate(endDate, endDays);

    // Use Intl.DateTimeFormat to get month names and days in the correct language
    const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    const startMonth = monthFormatter.format(startDate);
    const endMonth = monthFormatter.format(endDate);
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    
    // Use Intl.RelativeTimeFormat to detect locale conventions for date ordering
    // This helps determine if the locale uses day-first or month-first format
    const dateTimeFormatter = new Intl.DateTimeFormat(locale, { 
      month: 'long', 
      day: 'numeric' 
    });
    const parts = dateTimeFormatter.formatToParts(new Date());
    const dayIndex = parts.findIndex(p => p.type === 'day');
    const monthIndex = parts.findIndex(p => p.type === 'month');
    const isDayFirst = dayIndex < monthIndex;
    
    // Format according to locale conventions
    if (startMonth === endMonth) {
      // Same month
      if (isDayFirst) {
        return `${startDay}-${endDay} ${dateConnector} ${startMonth}`.trim();
      } else {
        return `${startMonth} ${startDay}-${endDay}`;
      }
    } else {
      // Different months
      if (isDayFirst) {
        return `${startDay} ${dateConnector} ${startMonth} - ${endDay} ${dateConnector} ${endMonth}`.trim();
      } else {
        return `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
      }
    }
  }

  function addBusinessDaysToDate(date, days, checkHolidays = true) {
    let count = 0;
    while (count < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() === 0 || date.getDay() === 6) continue; // Saltar fines de semana

      const formattedDate = date.toISOString().split('T')[0];
      if (checkHolidays && holidays.has(formattedDate)) continue; // Saltar festivos
      count++;
    }
  }


  
  function createExpressContainer() {
    const expressContainer = document.createElement('div');
    expressContainer.className = 'express_container';
  
    const detailsElement = document.createElement('details');
    const summaryElement = document.createElement('summary');
  
    const expressShippingDiv = document.createElement('div');
    expressShippingDiv.className = 'express_shipping';
    expressShippingDiv.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" height="18" width="18">
        <path stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" stroke="#0032A7"
          d="M5.625 7.125L12.3751 3M9.00009 9.375L15.7501 5.25M9.00009 9.375L2.25009 5.25M9.00009 9.375V16.875M7.12509 16.125V16.125C7.44574 16.3174 7.60607 16.4136 7.76491 16.4854C8.55015 16.8401 9.45003 16.8401 10.2353 16.4854C10.3941 16.4136 10.5544 16.3174 10.8751 16.125L14.1697 14.1483C15.0195 13.6384 15.4444 13.3834 15.753 13.0324C16.0261 12.7218 16.2321 12.3581 16.3579 11.9641C16.5001 11.5188 16.5001 11.0233 16.5001 10.0323V7.96771C16.5001 6.97669 16.5001 6.48117 16.3579 6.03593C16.2321 5.64192 16.0261 5.27818 15.753 4.96757C15.4444 4.61657 15.0195 4.36163 14.1697 3.85175L11.4697 2.23175C10.5718 1.69301 10.1228 1.42364 9.64356 1.31839C9.21963 1.2253 8.78055 1.2253 8.35663 1.31839C7.87736 1.42364 7.42841 1.69301 6.53051 2.23175L3.10789 4.28532C2.96114 4.37337 2.88776 4.4174 2.82122 4.46233C2.04211 4.98844 1.55467 5.84935 1.50439 6.78811C1.50009 6.86828 1.50009 6.95386 1.50009 7.125V7.125M0.75 9.75H4.75781M1.75781 12H5.50781M3.25781 14.25H6.25781"/>
      </svg>
      <span>${window.themeTranslations.need_it_sooner}</span>
      <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
      </svg>
    `;
  
    summaryElement.appendChild(expressShippingDiv);
    detailsElement.appendChild(summaryElement);
  
    const finalContainer = document.createElement('div');
    finalContainer.className = 'accordion__content final rte';
  
    const topParagraph = document.createElement('p');
    topParagraph.className = 'top';
    // Ensure country name is translated (use window.themeData.country_name which is always translated)
    const translatedCountry = window.themeData?.country_name || themeData.country_name;
    topParagraph.textContent = window.themeTranslations.express_to_country.replace('{{ country }}', translatedCountry);
  
    const code = themeData.country_code;
    const costString = expressShippingCosts[code] || expressShippingCosts.default;
  
    const subParagraph = document.createElement('p');
    subParagraph.className = 'sub';
    subParagraph.innerHTML = `
      ${window.themeTranslations.expected_by.replace('{{ date }}', addBusinessDays(1))} 
      <span style="float: right;color: #151414;">
        ${costString}
      </span>
    `;
  
    finalContainer.appendChild(topParagraph);
    finalContainer.appendChild(subParagraph);
    detailsElement.appendChild(finalContainer);
    expressContainer.appendChild(detailsElement);
  
    return expressContainer;
  }

  // --- SCROLL TOGGLES (DISABLED) ---
  // Sticky behavior commented out - not currently in use
  /*
  function setupToggleDivScroll() {
    const toggleDivs = cache.toggleDivs || document.querySelectorAll('.toggle-div');
    const firstColumn = cache.firstColumn || document.querySelector('.firstColumn');

    if (firstColumn && toggleDivs.length) {
      let lastExecution = 0;
      const debounceTime = 100;

      const handleScroll = () => {
        const firstColumnHeight = firstColumn.getBoundingClientRect().bottom;

        toggleDivs.forEach((div) => {
          if (firstColumnHeight <= window.innerHeight) {
            div.style.position = "sticky";
            div.style.padding = "16px 16px 16px 0";
          } else {
            div.style.position = "fixed";
            div.style.padding = "16px";
          }
        });
      };

      const debouncedScrollHandler = () => {
        const now = Date.now();
        if (now - lastExecution > debounceTime) {
          lastExecution = now;
          handleScroll();
        }
      };

      window.addEventListener('scroll', debouncedScrollHandler, { passive: true });
    }
  }
  */

  // --- FREQUENTLY BOUGHT INTERACTION (REMOVED) ---
  // Dead code removed for performance optimization
})();